import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Alert } from 'reactstrap';
import { ErrorBoundary } from 'react-error-boundary';
//import { bestSellingProducts } from "../../common/data";

import { API_BASE_URL } from '../../config';

const BestSellingProducts = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    // 分页数据计算 - Add null safety
    const currentData = (props.data || []).slice((currentPage-1)*5, currentPage*5);
     
    console.log("data",props)
    return (
        <React.Fragment>
            <Col xl={6}>
                <Card>
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Best Selling Products</h4>
                        <div className="flex-shrink-0">
                            <button type="button" className="btn btn-soft-secondary btn-sm">
                                <span className="fw-semibold text-uppercase fs-12">Sort by: </span>
                                <span className="text-muted">Today</span>
                            </button>
                        </div>
                    </CardHeader>

                    <CardBody>
                        <div className="table-responsive table-card">
                            <table className="table table-hover table-centered align-middle table-nowrap mb-0">
                                <tbody>
                                    {currentData.map((item, key) => (
                                        <tr key={key}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm bg-light rounded p-1 me-2">
                                                        <img  src={API_BASE_URL + "/file/product/image/"+item.img} alt="" className="img-fluid d-block" />
                                                    </div>
                                                    <div>
                                                        <h5 className="fs-14 my-1 text-truncate" style={{maxWidth: '200px'}}>
                                                            <Link to={"/product-detail?productId="+item.id}  className="text-reset">{item.label}</Link>
                                                        </h5>
                                                        <span className="text-muted">{item.date}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <h5 className="fs-14 my-1 fw-normal">${(item.price || 0).toFixed(2)}</h5>
                                                <span className="text-muted">Price</span>
                                            </td> 
                                            <td>
                                                <h5 className="fs-14 my-1 fw-normal">{item.stock ? item.stock : <span className="badge bg-danger-subtle text-danger">Out of stock</span>} </h5>
                                                <span className="text-muted">Stock</span>
                                            </td>
                                            <td>
                                                <h5 className="fs-14 my-1 fw-normal">${(item.amount || 0).toFixed(2)}</h5>
                                                <span className="text-muted">Amount</span>
                                            </td>
                                        </tr>
                                    ))} 
                                </tbody>
                            </table>
                        </div>

                        <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
                            <div className="col-sm">
                                <div className="text-muted">
                                    Showing <span className="fw-semibold">{Math.min(5, (props.data || []).length - (currentPage-1)*5)}</span> of 
                                    <span className="fw-semibold"> {(props.data || []).length}</span> Results
                                </div>
                            </div>
                            <div className="col-sm-auto mt-3 mt-sm-0">
                                <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <Link to="#" className="page-link" onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}>←</Link>
                                    </li>
                                    {Array.from({length: Math.ceil((props.data || []).length / 5)}).map((_, i) => (
                                        <li key={i} className={`page-item ${currentPage === i+1 ? 'active' : ''}`}>
                                            <Link to="#" className="page-link" onClick={() => setCurrentPage(i+1)}>{i+1}</Link>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === Math.ceil((props.data || []).length/5) ? 'disabled' : ''}`}>
                                        <Link to="#" className="page-link" onClick={() => setCurrentPage(p => p + 1)}>→</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </CardBody>
                </Card>
            </Col>
        </React.Fragment >
    );
};

// Error Boundary Fallback Component
const BestSellingProductsErrorFallback = ({ error, resetErrorBoundary }) => (
  <Col xl={6}>
    <Card>
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">Best Selling Products</h4>
      </CardHeader>
      <CardBody>
        <Alert color="warning" className="mb-0">
          <h6 className="alert-heading">Unable to load product data</h6>
          <p className="mb-2">There was an issue loading the best selling products data.</p>
          <button 
            className="btn btn-outline-warning btn-sm" 
            onClick={resetErrorBoundary}
          >
            Try Again
          </button>
        </Alert>
      </CardBody>
    </Card>
  </Col>
);

// Wrapped component with Error Boundary
const SafeBestSellingProducts = (props) => (
  <ErrorBoundary 
    FallbackComponent={BestSellingProductsErrorFallback}
    onReset={() => window.location.reload()}
  >
    <BestSellingProducts {...props} />
  </ErrorBoundary>
);

export default SafeBestSellingProducts;